import { render, staticRenderFns } from "./chinamap.vue?vue&type=template&id=04a3903e&scoped=true&"
import script from "./chinamap.vue?vue&type=script&lang=js&"
export * from "./chinamap.vue?vue&type=script&lang=js&"
import style0 from "./chinamap.vue?vue&type=style&index=0&id=04a3903e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "04a3903e",
  null
  
)

export default component.exports